import React from 'react';
import PropTypes from 'prop-types';
import MuiTable from '@material-ui/core/Table';
import styled from 'src/ui/library/styled';

const styles = theme => ({
  root: {
    borderCollapse: 'collapse',
  },
});

class Table extends React.Component {
  static propTypes = {
    /** Children for table to render */
    children: PropTypes.node.isRequired,
  };

  render() {
    const { classes, children } = this.props;

    return (
      <MuiTable role={undefined} className={classes.root}>
        {children}
      </MuiTable>
    );
  }
}

export default styled(Table)(styles);
